export default __webpack_public_path__ + "static/media/marker.ef307f00.png";